<template lang="pug">
#graficoNdvi
    div(v-show='possuiDadosNDVI')
        apex-charts.component.apexcharts-canvas(
            type='line',
            height='300',
            :options='options',
            :series='series',
            ref='chart'
        )

    div(v-show='!possuiDadosNDVI')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            :message='noResultMessage'
        )
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import { GRAFICO_MONITORAMENTO_NDVI } from '../../../utils/layouts/graficos';
import EmptyResult from '../../EmptyResult';

export default {
    components: {
        ApexCharts,
        EmptyResult
    },

    props: {
        dadosMonitoramentoNDVI: {
            type: Array,
            require: true
        },
        dadosPrecipitacaoSafraAtual: {
            type: Array
        }
    },

    data() {
        return {
            dadosNDVI: null,
            dadosPrecipitacao: null,
            series: [],
            options: {},
            colors: []
        };
    },

    computed: {
        possuiDadosNDVI() {
            return this.dadosNDVI && this.dadosNDVI.length;
        },
        noResultMessage() {
            return 'Ainda não há dados de índice de vegetação para a área';
        }
    },

    watch: {
        dadosMonitoramentoNDVI() {
            this.configure();
        }
    },

    methods: {
        configure() {
            this.dadosNDVI = this.dadosMonitoramentoNDVI;
            let dadosComuns = [];
            let datas = [];
            let dadosAcuracia = [];
            let color = '';

            this.dadosNDVI.map(dados => {
                let obj = {
                    dataProcessamento: new Date(
                        dados.dataProcessamento
                    ).toLocaleDateString('pt-BR'),
                    ndviPercentual: dados.ndviPercentual
                };
                datas.push(obj.dataProcessamento);
                if (
                    ['MENOR_50', 'DE_51_A_80', 'MAIOR_80'].includes(
                        dados.codigoAcuracia
                    )
                ) {
                    if (dados.codigoAcuracia === 'MENOR_50') {
                        color = '#D6D951';
                    }
                    if (dados.codigoAcuracia === 'DE_51_A_80') {
                        color = '#889306';
                    }
                    if (dados.codigoAcuracia === 'MAIOR_80') {
                        color = '#63AF01';
                    }
                    dadosAcuracia.push(obj);
                } else {
                    dadosComuns.push(obj);
                }
            });

            let datasUnicas = [...new Set(datas)];

            datasUnicas.sort((a, b) => {
                const dateA = new Date(a.split('/').reverse().join('/'));
                const dateB = new Date(b.split('/').reverse().join('/'));
                return dateA - dateB;
            });

            if (dadosComuns.length <= 0) {
                dadosAcuracia = dadosAcuracia.sort((a, b) => a.data - b.data);

                GRAFICO_MONITORAMENTO_NDVI.colors = [color];
                this.options = Object.assign(GRAFICO_MONITORAMENTO_NDVI);

                this.options.xaxis.categories = [];

                this.options.xaxis.categories.push(...datasUnicas);

                let porcentagemNdviAcuracia = datasUnicas.map(data => {
                    const rangeExiste = dadosAcuracia.find(
                        range => range.dataProcessamento === data
                    );
                    if (rangeExiste) {
                        return rangeExiste.ndviPercentual / 100;
                    }
                    return null;
                });

                this.options.yaxis[0].min = 0;

                this.options.stroke.curve = [];

                this.options.stroke.curve[0] =
                    porcentagemNdviAcuracia.filter(Boolean).length !== 0
                        ? 'smooth'
                        : '';

                this.series = [
                    {
                        name: 'Índice de vegetação para Soja:',
                        type: 'line',
                        data: porcentagemNdviAcuracia
                    }
                ];

                this.$refs.chart.updateOptions(this.options);
            } else {
                dadosComuns = dadosComuns.sort((a, b) => a.data - b.data);

                GRAFICO_MONITORAMENTO_NDVI.colors = ['#DC610D'];
                this.options = Object.assign(GRAFICO_MONITORAMENTO_NDVI);

                this.options.xaxis.categories = [];

                this.options.xaxis.categories.push(...datasUnicas);

                let porcentagemNdviDadosComuns = datasUnicas.map(data => {
                    const rangeExiste = dadosComuns.find(
                        range => range.dataProcessamento === data
                    );
                    if (rangeExiste) {
                        return rangeExiste.ndviPercentual / 100;
                    }
                    return null;
                });

                this.options.yaxis[0].min = 0;

                this.options.stroke.curve = [];

                this.options.stroke.curve[0] =
                    porcentagemNdviDadosComuns.filter(Boolean).length !== 0
                        ? 'smooth'
                        : '';

                this.series = [
                    {
                        name: 'Índice de vegetação:',
                        type: 'line',
                        data: porcentagemNdviDadosComuns
                    }
                ];

                this.$refs.chart.updateOptions(this.options);
            }
        }
    },

    mounted() {
        this.configure();
    }
};
</script>

<style lang="scss" scoped></style>
